import React from "react";

import SEO from "../components/SEO";
import NavSection from "../components/partials/SubPagesNav";
import HeroVideoSection from "@src/components/partials/press/HeroVideoSection";
import ContactSection from "@src/components/partials/press/ContactSection";
import MainSection from "@src/components/partials/press/MainSection";

const PressPage = () => {
  return (
    <>
      <SEO title="page_titles.press" description="page_descriptions.press" />
      <NavSection active="press" />
      <HeroVideoSection />
      <MainSection />
      <ContactSection />
    </>
  );
};
export default PressPage;
